// extracted by mini-css-extract-plugin
export var filterIncDec = "_9h-0";
export var leftBorder = "_9h-1";
export var rightBorder = "_9h-2";
export var stringInput = "_9h-3";